import { render, staticRenderFns } from "./AiChatWidget.vue?vue&type=template&id=053e9048&scoped=true&"
import script from "./AiChatWidget.vue?vue&type=script&lang=js&"
export * from "./AiChatWidget.vue?vue&type=script&lang=js&"
import style0 from "./AiChatWidget.vue?vue&type=style&index=0&id=053e9048&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053e9048",
  null
  
)

/* custom blocks */
import block0 from "./AiChatWidget.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('053e9048')) {
      api.createRecord('053e9048', component.options)
    } else {
      api.reload('053e9048', component.options)
    }
    module.hot.accept("./AiChatWidget.vue?vue&type=template&id=053e9048&scoped=true&", function () {
      api.rerender('053e9048', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/StationPlaceEvents/AiChatWidget.vue"
export default component.exports